import React, { useState } from 'react';
import { useGameStore } from '../store/gameStore';
import Tile from './Tile';

const Slot = ({ index, tile }) => {
  const [isDragOver, setIsDragOver] = useState(false);
  const { tileSize, selectTile, placeTile, clearSelection, selectedTile, openStrokeModal } = useGameStore();
  
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };
  
  const handleDragLeave = () => {
    setIsDragOver(false);
  };
  
  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    placeTile(index);
  };
  
  const handleClick = () => {
    if (selectedTile) {
      placeTile(index);
    }
  };
  
  const handleTileClick = () => {
    if (tile) {
      // Open stroke order modal for this character
      openStrokeModal(tile);
    }
  };
  
  const slotStyle = {
    width: `${tileSize}px`,
    height: `${tileSize}px`,
    borderRadius: `${tileSize * 0.19}px`,
    border: isDragOver ? '2px solid #6366f1' : '2px dashed #475569',
    background: isDragOver ? 'rgba(99, 102, 241, 0.15)' : 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'border-color 0.15s, background 0.15s',
    cursor: 'pointer',
  };
  
  return (
    <div
      className={`slot ${isDragOver ? 'drag-over' : ''}`}
      style={slotStyle}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={handleClick}
      data-slot-index={index}
    >
      {tile ? (
        <Tile 
          tile={tile} 
          location="slot" 
          slotIndex={index}
          onClick={handleTileClick}
        />
      ) : null}
    </div>
  );
};

export default Slot;
